import { registerPlugin } from "@capacitor/core";
import { AlertPlugin } from "./definitios";

const Alert = registerPlugin<AlertPlugin>('Alert');

export * from './definitios'

export { Alert }

